<template>
    <div class="-mx-4 flex border-b border-theme-border" role="tablist">
        <button
            v-for="tab in tabs"
            :id="`notebook-tab-${tab.id}`"
            :key="tab.id"
            role="tab"
            :aria-selected="tab.isActive ? 'true' : 'false'"
            :aria-controls="`notebook-tabpanel-${tab.id}`"
            class="flex flex-1 cursor-pointer items-center justify-center border-b-2 bg-transparent px-1 py-2.5 text-[13px] font-medium text-theme-toolbar-icon transition-colors hover:text-theme-text focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-theme-accent"
            :class="tab.isActive ? 'border-theme-accent text-theme-accent' : 'border-transparent'"
            @click="tab.action"
        >
            {{ tab.label }}
        </button>
    </div>
</template>

<script>
'use strict';

import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
        ...mapGetters(['showHighlightsAndNotes', 'canUseBookmarks']),

        tabs() {
            const tabs = [
                {
                    id: 'all',
                    label: this.localizations[this.lang].all,
                    isActive: this.showHighlightsAndNotes,
                    action: this.showHighlightsAndNotesTab,
                },
                {
                    id: 'highlights',
                    label: this.localizations[this.lang].highlights,
                    isActive: this.ui.features.highlights.opened,
                    action: this.toggleHighlights,
                },
                {
                    id: 'notes',
                    label: this.localizations[this.lang].notes,
                    isActive: this.ui.features.notes.opened,
                    action: this.toggleNotes,
                },
            ];

            // Bookmarks is the only tab gated by a host feature flag; hide the tab entirely
            // when the tenant has bookmarks disabled (mirrors the header button's canUseBookmarks).
            if (this.canUseBookmarks) {
                tabs.push({
                    id: 'bookmarks',
                    label: this.localizations[this.lang].bookmarks,
                    isActive: this.ui.features.bookmarks.opened,
                    action: this.showBookmarksTab,
                });
            }

            return tabs;
        },
    },
    methods: {
        ...mapActions(['toggleHighlights', 'toggleNotes', 'showHighlightsAndNotesTab', 'showBookmarksTab']),
    },
};
</script>
